export const componentTypes = ['primary', 'success', 'warning', 'danger', 'error', 'info'] as const
export type ComponentType   = typeof componentTypes[number]

